import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { useWorkspaceStore } from "@/hooks/use-workspace";
import { getAiEngine } from "@/lib/ai-engine";
import { studioHref, type StudioTarget } from "@/lib/content-links";

/** Builds engine-aware links into Content Studio for the active workspace (see lib/content-links.ts). */
export function useStudioHref() {
  const { activeWorkspaceId } = useWorkspaceStore();
  const { data: workspaces } = useQuery<any[]>({ queryKey: ["/api/workspaces"] });
  const engine = getAiEngine(workspaces?.find((w: any) => w.id === activeWorkspaceId));
  return useCallback((target: StudioTarget, params?: Record<string, string>) => studioHref(engine, target, params), [engine]);
}
